var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveRowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-desktop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M11.7072 7.29492C12.0977 7.68548 12.0977 8.31974 11.7072 8.71029L5.70828 14.7092C5.31772 15.0997 4.68347 15.0997 4.29291 14.7092C3.90236 14.3186 3.90236 13.6844 4.29291 13.2938L9.58568 8.00104L4.29604 2.70828C3.90549 2.31772 3.90549 1.68347 4.29604 1.29291C4.68659 0.902362 5.32085 0.902362 5.7114 1.29291L11.7103 7.2918L11.7072 7.29492Z",
    fill: "#003267"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveRowRight);
export default __webpack_public_path__ + "static/media/move-row-right.bd770595cb7c6362a5530fcde8b5d5de.svg";
export { ForwardRef as ReactComponent };